import { isEqualDate } from '../../utilities/calendarData.js';
import React, {createContext, useContext, useReducer} from 'react';

export const StateContext = createContext();

export const StateProvider = ({reducer, initialState, children}) =>(
  <StateContext.Provider value={useReducer(reducer, initialState)}>
    {children}
  </StateContext.Provider>
);

export const useStateValue = () => useContext(StateContext);

function getDates({ userAction, selectedDate }, state) {
  var dates = state.controllers.selectedDates;
  if (userAction !== state.controllers.userAction) {
    dates = [selectedDate];
  } else if (userAction === 'selectRange') {
    if (dates.length > 1) {
      dates = [selectedDate]
    } else {
      if (dates[0].isBefore(selectedDate)) {
        dates.push(selectedDate)
      } else {
        dates.unshift(selectedDate)
      }
    }
  } else if (userAction === 'selectDates') {
    var found = dates.find((date) => isEqualDate(selectedDate, date));
    if (found && found !== null) {
      dates.splice(dates.indexOf(found), 1);
    } else {
      dates.push(selectedDate);
    }
  }

  return dates;
}

function getState({ userAction, selectedDate }, state) {
  if (state.controllers.userAction !== null) {
    var dates = getDates({ userAction, selectedDate }, state);
    return { userAction: dates.length === 0 ? null : userAction, selectedDates: dates}
  } else {
    return { userAction: userAction, selectedDates: [selectedDate] }
  }
}

export const initialState = {
  controllers: {
    userAction: null,
    selectedDates: []
  },
  dates: []
};


export function reducer(state, action) {
  switch (action.type) {
    case 'userAction':
      return {
        ...state,
        controllers: getState(action, state)
      };

    case 'resetAction':
      return {
        ...state,
        controllers: {
          userAction: null,
          selectedDates: []
        }
      };

    case 'updateDates':
      return {
        ...state,
        dates: action.dates
      };

    default:
      return state;
  }
};
